import { createRouter, createWebHashHistory } from 'vue-router'
import Home from "@/views/Home.vue";
import TheGame from "@/views/TheGame.vue";

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/game',
    name: 'game',
    component: TheGame
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
